import React from "react";
import Navigation from "./Navigation/Navigation";
import IntroCard from "./IntroCard/IntroCard";
import AboutMe from "./About/About";
import BackgroundEffects from "../UI/BackgroundEffects/BackgroundEffects";
import classes from "./Header.module.css";

const Header = () => {
  return (
    <div className={classes.Header}>
      <BackgroundEffects variant="default" />
      <Navigation />
      <IntroCard />
      <AboutMe />
    </div>
  );
};

export default Header;
